import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import './index.less';
import PersonalBasic from './PersonalBasic';
import PersonalSetting from './PersonalSetting';

const Personal = props => {
  return (
    <div className="personal-container">
      <PersonalBasic />
      <PersonalSetting />
    </div>
  );
};

const mapStateToProps = state => {
  return state;
};

export default connect(mapStateToProps)(Personal);



// WEBPACK FOOTER //
// ./src/routes/Personal/Personal.js